import { useState } from "react";
import { FiX } from "react-icons/fi";
import CategoryEditor from "../CategoryEditor";
import Button from "../ui/Button";

export default function CategoryEditorModal({onClose, category}) {
    const [newCategory, setNewCategory] = useState(category || {
        name: 'New Category',
        allow_types: ['*/*'],
        allow_wsc_import: false,
    })

    return (
        <div className='w-full h-full max-w-[500px] flex flex-col bg-background border-l'>
            <div className='flex justify-between py-2 px-4 items-center'>
                <span className='text-white text-lg font-bold'>Category</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}><FiX className="w-6 h-6" /></div>
            </div>
            <div className='flex-1 overflow-hidden'>
                <CategoryEditor defaultValue={newCategory} onChange={(category) => setNewCategory(category)} />
            </div>
            <div className='flex p-2 gap-4'>
                <Button type='primary' className='min-w-20' onClick={() => onClose(newCategory)}>Save</Button>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
            </div>
        </div>
    )
}